import { workspaceModuleApi } from '../api';
import { useState } from 'react';
import { FetchStatus } from 'types/api';
import { isAxiosError } from 'axios';
import { QAItem } from 'types/api.d';

export const useFetchQa = () => {
  const [status, setFetchStatus] = useState<FetchStatus>('idle');
  const [qa, setQa] = useState<QAItem[]>([]);
  const [totalItems, setTotalItems] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const fetchQa = async (page: number = 1) => {
    try {
      setFetchStatus('loading');
      const response = await workspaceModuleApi.getQaList(page);
      setQa(response.results);
      setTotalItems(response.total);
      setFetchStatus('success');
    } catch (error) {
      if (isAxiosError(error)) {
        setError(error.response?.data.detail || error.message);
      } else {
        setError('An error occurred');
      }
      setFetchStatus('failed');
    }
  };

  return { status, qa, totalItems, error, fetchQa, setFetchStatus };
};
